import { styled } from "@mui/material";

const NoUnderlineALink = styled("a")({
  textDecoration: "none",
  color: "#000",
});

export default NoUnderlineALink;
